
const InfoIcon = ({ size = 16, color = "#667085" }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 16 16" fill="none">
      <g clipPath="url(#clip0_1325_11428)">
        <path d="M7.99967 14.6665C11.6816 14.6665 14.6663 11.6817 14.6663 7.99983C14.6663 4.31793 11.6816 1.33316 7.99967 1.33316C4.31778 1.33316 1.33301 4.31793 1.33301 7.99983C1.33301 11.6817 4.31778 14.6665 7.99967 14.6665Z" stroke={color} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M8 10.6667V8" stroke={color} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M8 5.33316H8.00583" stroke={color} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_1325_11428">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default InfoIcon